<template lang="pug">
//- a.listing()
.listing(
  @click='$router.push({ name: "SinglePage", params: { id: listing.link } })',
  :is='$store.getters.desktop ? "div" : "a"',
  :href='`${$frontname}listing/${listing.link}`'
)
  .listing-image.zoom: img(:src='imgUrl()', alt)
  .listing-price {{ listing.priceCondition == "from" ? listing.priceCondition : "" }} {{ listing.priceValue | toCurrency }}
  .listing-title {{ listing.title }}
  .listing-props
    .listing-prop(v-if='listing && listing.beds')
      SvgComponent(name='bed')
      span {{ listing.beds }} bd
    //- span(v-if='listing && listing.beds')
    .listing-prop(v-if='listing && listing.baths')
      SvgComponent(name='bath')
      span {{ listing.baths }}{{ halfBathRender() }} ba 
    //- span(v-if='listing && listing.baths')
    .listing-prop(v-if='listing && listing.sqft')
      SvgComponent(name='sqft')
      span {{ listing.sqft }} sqft
  .listing-location {{ listing.address }}
</template>

<script>
  import SvgComponent from '@/components/SvgComponent';

  export default {
    components: { SvgComponent },
    props: {
      listing: Object,
    },
    methods: {
      imgUrl() {
        return this.$hostname + (this.listing.image.formats.medium?.url || this.listing.image.url);
      },
      halfBathRender() {
        if (!this.listing.halfbaths) {
          return '';
        }
        if (this.listing.halfbaths == 1) {
          return '.5';
        }
        if (this.listing.halfbaths > 1) {
          return ` + ${this.listing.halfbaths}half`;
        }
      },
    },
  };
</script>

<style lang="scss">
  .listing {
    cursor: pointer;
    line-height: 36.54px;
    font-size: 20px;
    color: #1F1E1E;

    @include middle {
      line-height: 1.2em;
    }
    @include tablet {
      line-height: 1em;
    }
    &-image {
      position: relative;

      height: 459px;
      width: 100%;
      
      @include middle {
        height: 459px;
        // width: 320px;
      }
      @include small {
        height: 370px;
        // width: 250px;
      }
      img {
        object-fit: cover;
        width: 100%;
        height: 100%;
      }
      user-select: none;
      @include tablet {
        height: 269px;
        width: 100%;
        padding: 0 16px;
        // width: 360px;
      }
    }
    &-title {
      margin-top: 8px;
      font-size: 26px;
      font-weight: 700;
      @include middle {
        /* font-size: 18px; */
      }
      @include tablet {
        font-size: 16px;

        /* margin-top: 16px; */
      }
    }
    &-location {
      font-weight: 300;
      font-size: 26px;
      margin-top: 8px;
      color: #1F1E1E;
      line-height: 32px;
      @include middle {
        font-size: 18px;
      }
      @include tablet {
        font-size: 24px;
      }

       @include phone {
        margin-top: 8px;
        font-size: 16px;
      }
    }
    &-price {
      font-weight: 700;
      margin-top: 32px;
      font-size: 30px;
      line-height: 32px;
      
      /* line-height: 24px; */
      @include middle {
        /* font-size: 16px; */
      }

      @include tablet {
        margin-top: 16px;
        font-size: 20px;
      }
    }
    &-props {
      display: flex;
      gap: 20px;
      /* @include gap(40px, row); */
      margin-top: 8px;
     
    }
    &-prop {
      display: flex;
      align-items: center;
      @include gap(10px, row);
      font-size: 22px;
      

      @include xl {
        font-size: 22px;
        line-height: 22px;
      }

      @include phone {
        font-size: 16px;
      }

      
    }
    &-info > * {
      margin-left: 16px;
    }
  }
  .listing-title,
  .listing-location,
  .listing-props,
  .listing-price {
    @include phone {
      margin-left: 16px;
    }
  }

  .singleAlso {
    .listing-title,
    .listing-location,
    .listing-props,
    .listing-price {
      margin-left: 20px;
      @include tablet {
        margin-left: 16px;
      }
    }
  }
  .singleAlso .listing-image {
    height: 386px;
    width: 386px;
    @include middle {
      height: 320px;
      width: 320px;
    }
    @include small {
      height: 250px;
      width: 250px;
    }
    @include tablet {
      height: 360px;
      width: 100%;
    }
  }
</style>
